import { useState } from "react";

const SideImage = (props: any) => {
    const { articlePayload, setArticlePayload } = props;
    const [pwaImage, setPwaImage] = useState("");
    const [desktopImage, setDesktopImage] = useState("");
    const [authorImage, setAuthorImage] = useState("")
    const [authorSocialMediaLinks, setAuthorSocialMediaLinks] = useState(articlePayload.authorSocialMediaLinks);
    const [platform, setPlatform] = useState("");
    const [socialMediaErrors, setSocialMediaErrors] = useState<{[key: string]: string}>({});

    const handleDesktopImageChange = (e: any) => {
        const file = e.target.files[0];
        setArticlePayload({ ...articlePayload, desktopImageUrl: file })
        if (file) {
            const reader: any = new FileReader();
            reader.onloadend = () => {
                setDesktopImage(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleMobileImageChange = (e: any) => {
        const file = e.target.files[0];
        setArticlePayload({ ...articlePayload, pwaImageUrl: file })
        if (file) {
            const reader: any = new FileReader();
            reader.onloadend = () => {
                setPwaImage(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleAuthorImageChange = (e: any) => {
        const file = e.target.files[0];
        setArticlePayload({ ...articlePayload, authorImageUrl: file })
        if (file) {
            const reader: any = new FileReader();
            reader.onloadend = () => {
                setAuthorImage(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const validateSocialMediaUrl = (platform: string, url: string): boolean => {
        if (!url) return true; // Empty URLs are allowed
        
        const patterns = {
            linkedin: /^https?:\/\/(www\.)?linkedin\.com\/(in|company|pub)\/[a-zA-Z0-9-_.%]+\/?(\?.*)?$/,
            twitter: /^https?:\/\/(www\.)?(twitter\.com|x\.com)\/[a-zA-Z0-9_]+\/?(\?.*)?$/,
            facebook: /^https?:\/\/(www\.)?facebook\.com\/[a-zA-Z0-9.]+\/?(\?.*)?$/
        };
        
        return patterns[platform as keyof typeof patterns]?.test(url) || false;
    };

    const handleAuthorSocialMediaLinksChange = (e: any) => {
        const { name, value } = e.target;

        // Clear previous error for this field
        const newErrors = { ...socialMediaErrors };
        delete newErrors[name];

        // Validate URL if it's not empty  
        if (value && !validateSocialMediaUrl(name, value)) {
            newErrors[name] = `Please enter a valid ${name} URL`;
            e.target.setCustomValidity(`Please enter a valid ${name} URL`);
        } else {
            e.target.setCustomValidity('');
        }

        setSocialMediaErrors(newErrors);

        let updatedAuthorSocialMediaLinks = articlePayload.authorSocialMediaLinks.map((link:any) => 
            link.key === name ? { ...link, value: value } : link
        );

        setArticlePayload({ ...articlePayload, authorSocialMediaLinks: updatedAuthorSocialMediaLinks });
    };
    const handleSelectChange = (e:any) => {
        const selectedValue = e.target.value;
        setArticlePayload({ ...articlePayload, articleType: (selectedValue) || null });
    }

    return (
        <>
            <div className="image-container rounded shadow-[0_1px_4px_rgba(0,0,0,.2)]">
                <div className="desktop-view w-1/2 px-2 mt-4">
                    <label className="block text-xs mb-1.5 text-[#5E5D5D] font-medium">
                        Platform
                    </label>
                    <select
                        className="h-[30px] px-4 bg-white text-xs border text-[#5E5D5D] border-[#EAEAEA] h-9 px-3 rounded"
                        style={{ width: "200px" }}
                        value={ platform ? platform : (articlePayload.articleType === "supplier_page" || articlePayload.articleType === "supplier_blog") ? "supplier_page" : articlePayload.articleType || "" }
                        name="device"
                        onChange={(e)=>{handleSelectChange(e);setPlatform(e.target.value)}}
                    >
                        <option value="">Select</option>
                        <option value="article">Online</option>
                        <option value="supplier_page">Supplier</option>
                    </select>
                </div>

                {
                    (platform === "supplier_page" || platform === "supplier_blog" || articlePayload.articleType === "supplier_page" || articlePayload.articleType === "supplier_blog") && (
                        <div className="desktop-view w-1/2 px-2 mt-4">
                        <label className="block text-xs mb-1.5 text-[#5E5D5D] font-medium">
                             Type
                        </label>
                        <select
                            className="h-[30px] px-4 bg-white text-xs border text-[#5E5D5D] border-[#EAEAEA] h-9 px-3 rounded"
                            style={{ width: "200px" }}
                            value={articlePayload.articleType || ""}
                            name="device"
                            onChange={handleSelectChange}
                        >
                            <option value="supplier_page">Page</option>
                            <option value="supplier_blog">Blog</option>
                        </select>
                    </div>
                    )
                }


                <div className="desktop-view w-1/2 px-2 mt-4">
                    {/* LOCAL RENDER */}
                    {desktopImage && (
                        <div>
                            <img
                                src={desktopImage}
                            // alt="Image Preview"
                            />
                        </div>
                    )}

                    {articlePayload.desktopImageUrl && typeof articlePayload.desktopImageUrl === "string" && (
                        <div>
                            <img
                                src={"https://cdn.moglix.com/" + articlePayload.desktopImageUrl}
                            // alt="Image Preview"
                            />
                        </div>
                    )}
                    {articlePayload.desktopImageUrl && typeof articlePayload.desktopImageUrl === "string" && (
                        <a
                            className="text-[10px] text-[#3c3c3c]"
                            href={"https://cdn.moglix.com/" + articlePayload.desktopImageUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Preview Image
                        </a>
                    )}

                    <label className="block text-xs mb-1.5 text-[#5E5D5D] font-medium">
                        Desktop Image
                    </label>
                    <input
                        onChange={handleDesktopImageChange}
                        className="file w-full h-9 rounded border text-[#555] border-[#EAEAEA] p-2 outline-none text-sm font-light"
                        type="file"
                    />

                </div>

                <div className="mobile-view w-1/2 px-2 mt-8">
                    {/* LOCAL RENDER */}
                    {pwaImage && (
                        <div>
                            <img
                                src={pwaImage}
                            // alt="Image Preview"
                            />
                        </div>
                    )}

                    {articlePayload.pwaImageUrl && typeof articlePayload.pwaImageUrl === "string" && (
                        <div className="thumbnail-container">
                            <img
                                className="thumbnail"
                                src={"https://cdn.moglix.com/" + articlePayload.pwaImageUrl}
                            // alt="Image Preview"
                            />
                        </div>
                    )}
                    {articlePayload.pwaImageUrl && typeof articlePayload.pwaImageUrl === "string" && (
                        <a
                            className="text-[10px] text-[#3c3c3c]"
                            href={"https://cdn.moglix.com/" + articlePayload.pwaImageUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Preview Image
                        </a>
                    )}

                    <label className="block text-xs mb-1.5 text-[#5E5D5D] font-medium">
                        Mobile Image
                    </label>
                    <input
                        onChange={handleMobileImageChange}
                        className="file w-full h-9 rounded border text-[#555] border-[#EAEAEA] p-2 outline-none text-sm font-light"
                        type="file"
                    />
                </div>

                <div className="mobile-view w-1/2 px-2 mt-8">
                    {authorImage && (
                        <div>
                            <img
                                src={authorImage}
                            // alt="Image Preview"
                            />
                        </div>
                    )}
                    {articlePayload.authorImageUrl && typeof articlePayload.authorImageUrl === "string" && (
                        <div className="thumbnail-container">
                            <img
                                className="thumbnail"
                                src={"https://cdn.moglix.com/" + articlePayload.authorImageUrl}
                            // alt="Image Preview"
                            />
                        </div>
                    )}
                    {articlePayload.authorImageUrl && typeof articlePayload.authorImageUrl === "string" && (
                        <a
                            className="text-[10px] text-[#3c3c3c]"
                            href={"https://cdn.moglix.com/" + articlePayload.authorImageUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Preview Image
                        </a>
                    )}
                    <label className="block text-xs mb-1.5 text-[#5E5D5D] font-medium">
                        Author Image
                    </label>
                    <input
                        onChange={handleAuthorImageChange}
                        className="file w-full h-9 rounded border text-[#555] border-[#EAEAEA] p-2 outline-none text-sm font-light"
                        type="file"
                    />
                </div>

                <div className="social-media-section w-full px-2 mt-8">
                    <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                        <label className="block text-sm mb-4 text-[#5E5D5D] font-semibold flex items-center">
                            <svg className="w-5 h-5 mr-2 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.102m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
                            </svg>
                            Social Media Links
                        </label>
                        
                        <div className="space-y-4">
                            {articlePayload && 
                             articlePayload.authorSocialMediaLinks && 
                             Array.isArray(articlePayload.authorSocialMediaLinks) && 
                             articlePayload.authorSocialMediaLinks.length > 0 && 
                             (articlePayload.authorSocialMediaLinks as { key: string; value: string }[]).map(({ key, value }, index) => (
                                <div key={key} className="bg-white rounded-lg p-3 border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
                                    <div className="flex items-center mb-2">
                                        {key === 'linkedin' && (
                                            <div className="w-6 h-6 bg-blue-100 rounded flex items-center justify-center mr-3">
                                                <svg className="w-4 h-4 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                                                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                                                </svg>
                                            </div>
                                        )}
                                        {key === 'twitter' && (
                                            <div className="w-6 h-6 bg-blue-50 rounded flex items-center justify-center mr-3">
                                                <svg className="w-4 h-4 text-blue-400" fill="currentColor" viewBox="0 0 24 24">
                                                    <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
                                                </svg>
                                            </div>
                                        )}
                                        {key === 'facebook' && (
                                            <div className="w-6 h-6 bg-blue-50 rounded flex items-center justify-center mr-3">
                                                <svg className="w-4 h-4 text-blue-700" fill="currentColor" viewBox="0 0 24 24">
                                                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                                                </svg>
                                            </div>
                                        )}
                                        <span className="text-sm text-[#5E5D5D] font-medium capitalize">
                                            {key}
                                        </span>
                                    </div>
                                    
                                    <input
                                        key={key}
                                        name={key}
                                        value={value}
                                        onChange={handleAuthorSocialMediaLinksChange}
                                        className={`w-full h-10 rounded-md border text-[#555] px-3 py-2 outline-none text-sm transition-all duration-200 ${
                                            socialMediaErrors[key] 
                                                ? 'border-red-400 focus:border-red-500 focus:ring-2 focus:ring-red-100 bg-red-50' 
                                                : 'border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 hover:border-gray-400'
                                        }`}
                                        type="url"
                                        placeholder={`https://${key === 'twitter' ? 'twitter.com' : key === 'linkedin' ? 'linkedin.com/in' : 'facebook.com'}/username`}
                                        title={`Please enter a valid ${key} URL`}
                                    />
                                    
                                    {socialMediaErrors[key] && (
                                        <div className="text-xs text-red-600 mt-2 flex items-center bg-red-50 p-2 rounded">
                                            <svg className="w-4 h-4 mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                            </svg>
                                            {socialMediaErrors[key]}
                                        </div>
                                    )}
                                    
                                    {!socialMediaErrors[key] && value === '' && (
                                        <div className="text-xs text-gray-500 mt-2 bg-gray-50 p-2 rounded">
                                            {key === 'linkedin' && '💡 Example: https://linkedin.com/in/your-profile'}
                                            {key === 'twitter' && '💡 Example: https://twitter.com/your-handle'}
                                            {key === 'facebook' && '💡 Example: https://facebook.com/your-profile'}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                        
                        <div className="mt-4 p-3 bg-blue-50 rounded-lg border border-blue-200">
                            <div className="flex items-start">
                                <svg className="w-4 h-4 text-blue-600 mt-0.5 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                <div className="text-xs text-blue-700">
                                    <strong>Note:</strong> All social media fields are optional. Please ensure URLs match the respective platform domains for proper validation.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SideImage;
